import gql from 'graphql-tag';

export const solarmanModbusResponse = gql`
fragment devicesapires on DevicesAPIRes {
  deviceId
  ack
  content
  deviceSN
  orderId
  success
}`;
